import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "sticky-top-20" };
const _hoisted_2 = {
    class: "title",
    style: { "padding-left": "16px", "margin-bottom": "0px" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_treeview = _resolveComponent("g-treeview");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx._menu?.caption), 1),
        _createVNode(_component_g_treeview, {
            class: "mb-4",
            "data-source": _ctx._menu?.children,
            "data-structure": "tree"
        }, null, 8, ["data-source"])
    ]));
}
